import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    Checkbox,
    DefaultButton,
    Modal,
    PrimaryButton,
    TextField
} from '@fluentui/react';
import * as Api from "../../../../api/src"
import ModalHeader from '../../../../control/modalHeader';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
export interface ModaProductProps {
    IsOpen: boolean,
    onCloseModal: () => void;
    onSaveClick?: () => void;
    Item?: Api.ProductType | null
}
const ProductTypesApi = new Api.ProductTypesApi();
const ModaProduct = ({ onSaveClick, Item, IsOpen, onCloseModal }: ModaProductProps) => {
    const [isShow, SetIsShow] = React.useState(false)
    const [detail, SetDetail] = React.useState<Api.ProductType>({});
    const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
    const { t } = useTranslation();
    const { setToastData } = React.useContext(ToastAppMsgContext)
    const getTitle = (): string => {
        if (Item) {
            return t("EditProductType")
        }
        return t("NewProductType");
    }

    React.useEffect(() => {
        SetIsShow(IsOpen);
        if (IsOpen) {
            if (Item == null) {
                SetDetail({ States: Api.StatesEnum.Active });
            } else {
                getItemData();
            }
        } else {
            SetDetail({ States: Api.StatesEnum.Active });
        }
        SetNameErrorMessage("");
    }, [IsOpen]);
    const getItemData = async () => {
        var data = (await ProductTypesApi.apiProductTypesIdGet(Item?.Id || 0)).data;
        SetDetail(data.Data || { States: Api.StatesEnum.Active });
    }
    const onClose = () => {
        onCloseModal()
        SetIsShow(false)
    }
    const onSave = async () => {
        if (!detail.Name) {
            SetNameErrorMessage(t("NameIsRequired"));
            return;
        }
        var data = await ProductTypesApi.apiProductTypesPost({ Model: detail });
        if (!data || data.status != 200) return;
        setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
        onCloseModal();
        SetIsShow(false);
        if (onSaveClick) {
            onSaveClick();
        }
    }
    return (
        <Modal
            isOpen={isShow}
            isModeless={true}
        >
            <ModalHeader title={getTitle()} onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 700 }}>
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
                            <TextField autoFocus={true} errorMessage={nameErrorMessage} label={t("Name") + " (*)"} value={detail?.Name || ""}
                                onChange={(e, newValue) => { SetDetail({ ...detail, Name: newValue }); SetNameErrorMessage(""); }}></TextField>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
                            <Checkbox label={t("Active")} checked={detail?.States === Api.StatesEnum.Active ? true : false} onChange={(e, checked) => { SetDetail({ ...detail, States: checked ? Api.StatesEnum.Active : Api.StatesEnum.Inactive }); }}></Checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'modal-footer'}>
                <DefaultButton onClick={() => { onClose(); }} className={"margin-left-10"}>{t("Close")}</DefaultButton>
                <PrimaryButton className={"margin-left-10"} onClick={() => { onSave(); }}>{t("Save")}</PrimaryButton>
            </div>
        </Modal>
    );
}
export default ModaProduct;


